/**
 * Système de correspondance de croisements entre réservations
 * Utilise un seul tableau de réservations pour identifier les croisements
 */

class BookingCrossingMatcher {
  constructor(reservations) {
    this.reservations = reservations;
  }

  /**
   * Vérifie si deux réservations se croisent temporellement
   */
  static sesCroisent(reservation1, reservation2) {
    const entree1 = new Date(reservation1.location_date_debut);
    const sortie1 = new Date(reservation1.location_date_fin);
    const entree2 = new Date(reservation2.location_date_debut);
    const sortie2 = new Date(reservation2.location_date_fin);

    return entree1 <= sortie2 && entree2 <= sortie1;
  }

  /**
   * Vérifie si la date de début d'une réservation croise avec d'autres réservations
   */
  aCroisementEntree(reservationCible) {
    const dateEntreeCible = new Date(reservationCible.location_date_debut);

    return this.reservations.some(reservation => {
      // Ne pas comparer avec elle-même
      if (reservation.location_id === reservationCible.location_id) return false;

      // Vérifier si même lot
      if (reservation.location_lot.lot_id !== reservationCible.location_lot.lot_id) return false;

      const entreeAutre = new Date(reservation.location_date_debut);
      const sortieAutre = new Date(reservation.location_date_fin);

      // Vérifier si la date d'entrée de la réservation cible est dans la période d'une autre réservation
      return dateEntreeCible >= entreeAutre && dateEntreeCible <= sortieAutre;
    });
  }

  /**
   * Vérifie si la date de fin d'une réservation croise avec d'autres réservations
   */
  aCroisementSortie(reservationCible) {
    const dateSortieCible = new Date(reservationCible.location_date_fin);

    return this.reservations.some(reservation => {
      // Ne pas comparer avec elle-même
      if (reservation.location_id === reservationCible.location_id) return false;

      // Vérifier si même lot
      if (reservation.location_lot.lot_id !== reservationCible.location_lot.lot_id) return false;

      const entreeAutre = new Date(reservation.location_date_debut);
      const sortieAutre = new Date(reservation.location_date_fin);

      // Vérifier si la date de sortie de la réservation cible est dans la période d'une autre réservation
      return dateSortieCible >= entreeAutre && dateSortieCible <= sortieAutre;
    });
  }

  /**
   * Identifie le type de croisement pour chaque réservation
   */
  identifierTypeCroisement(reservation) {
    const aCroisementEntree = this.aCroisementEntree(reservation);
    const aCroisementSortie = this.aCroisementSortie(reservation);

    if (aCroisementEntree && aCroisementSortie) {
      return "Croisement à l'entrée et à la sortie";
    } else if (aCroisementEntree) {
      return "Croisement à l'entrée";
    } else if (aCroisementSortie) {
      return "Croisement à la sortie";
    }

    return null;
  }

  /**
   * Effectue la correspondance et enrichit le tableau avec les croisements
   */
  effectuerCorrespondance() {
    return this.reservations.map(reservation => ({
      ...reservation,
      croisement: this.identifierTypeCroisement(reservation)
    }));
  }
}

export default BookingCrossingMatcher;